import { render, staticRenderFns } from "./TeamMember.vue?vue&type=template&id=7242894e&scoped=true"
import script from "./TeamMember.vue?vue&type=script&lang=js"
export * from "./TeamMember.vue?vue&type=script&lang=js"
import style0 from "./TeamMember.vue?vue&type=style&index=0&id=7242894e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7242894e",
  null
  
)

export default component.exports